import React , { Component, Fragment}from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import MenuLeftUserInfo from '../../GlobalComponents/LeftMenuUserInfo/LeftMenuUserInfo'
import MenuLeftAdministrator from './MenuLeftAdministrator';
import MenuLeftTrainer from './MenuLeftTrainer'
class MenuLeft extends Component { 
  
  render() {
    const { location: { pathname }} = this.props;
    console.log('Menu left', this.props)
    if(this.props){
      const {menuLeftColor} = this.props
      var linkColor = ({  color: menuLeftColor || "#fff"})
    }
      return (
      <Fragment>
        <MenuLeftUserInfo userData={this.props.user} linkColor={linkColor} />
        { this.props.user.role === 'companyAdmin' ? 

          <MenuLeftAdministrator pathname={pathname} linkColor={linkColor}/> : ''

        }
        { this.props.user.role === 'trainer' ? 

          <MenuLeftTrainer pathname={pathname} linkColor={linkColor}/> : ''

        }
      </Fragment>
    )
  }
}
export default compose(
  withRouter
  )(MenuLeft)